module.exports = __webpack_public_path__ + "media/images/challenges/golden-ticket-22/sony-logo-ecb54aa2d9d6b4be7007eb0524c854cc.svg";